import { PublicKey } from '@solana/web3.js';

export const DEFAULTS = {
  // HARDCODE DEVNET HERE
  // NOTE: MOST SWAP TO MAIN NET FOR RELEASE
  CLUSTER: 'mainnet',
  // CLUSTER: 'devnet',
  GEM_BANK_PROG_ID: new PublicKey(
  'bankHHdqMuaaST4qQk6mkzxGeKPHWmqdgor6Gs8r88m'
  ),
  GEM_FARM_PROG_ID: new PublicKey(
  'farmL4xeBFVXJqtfxCzU9b28QACM7E2W2ctT6epAjvE'
  ),
};
